<template>
  <div>
    <Slider />
    <Loader v-if="loading" />
    <div class="container" v-else>
      <div class="row">
        <div class="col-md-9 Donation__wrapper">
          <category-bar @tabChanged="tabChanged" v-if="categories.length" :categories="categories" />
          <transition-group mode="out-in" tag="div" name="fade">
            <div class="row" :key="idx" v-for="(_produtcs, idx) of chunk(products, 3)">
              <donation-item
                class="mb-5 col-12 w-100"
                v-for="(product) in _produtcs"
                :product="product"
                :key="product.id"
              />
            </div>
          </transition-group>

          <div class="secure">
            <img src="@/assets/img/new-ssl.png" alt />
          </div>
        </div>
        <div class="col-md-3 px-0">
          <cart />
          <div class="Cart__logos">
            <img src="../assets/img/card-logos.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DonationItem from '@/components/DonationItem'
import Slider from '@/components/Slider'
import CategoryBar from '@/components/CategoryBar'
import Cart from '@/components/Cart'

export default {
  name: 'Donation',
  metaInfo: {
    title: 'Bağış Merkezi - İsmailağa Derneği',
    meta: [
      {
        name: 'description',
        content: `İsmailağa Derneği Resmî Web Sitesinde, 
          İsmailağa Camiasının yürüttüğü hizmetler hakkında kaynağından bilgiler ve 
          bağış ile destek yolları yer alıyor.`
      },
      {
        name: 'og:image',
        content: 'https://ismailagadernegi.org.tr/wp-content/uploads/2018/12/ismailaga-sosyal-varsayilan.jpg'

      },
      {
        name: 'twitter:description',
        content: `İsmailağa Derneği Resmî Web Sitesinde, 
        İsmailağa Camiasının yürüttüğü hizmetler hakkında kaynağından bilgiler 
        ve bağış ile destek yolları yer alıyor.`
      },
      {
        name: 'twitter:image',
        content: 'https://ismailagadernegi.org.tr/wp-content/uploads/2018/12/ismailaga-sosyal-varsayilan.jpg'
      },
      {
        name: 'twiiter:title',
        content: 'Bağış Merkezi - İsmailağa Derneği'
      }
    ]
  },
  data() {
    return {
      categories: [],
      allProducts: [],
      tabIndex: 0,
      loading: false
    }
  },
  components: {
    DonationItem,
    Slider,
    CategoryBar,
    Cart
  },
  methods: {
    tabChanged(idx) {
      this.tabIndex = idx
    }
  },
  computed: {
    ...mapState(['basketItems']),
    products() {
      return this.categories.length
        ? this.groupedProducts[this.categories[this.tabIndex].id]
        : []
    }
  },
  created() {
    this.loading = true
    this.$http.get('v2/product?per_page=500&order_by=order').then((res) => {
      this.groupedProducts = res.data.data.reduce((a, b) => {
        (a[b.category.id] = a[b.category.id] || []).push(b)
        return a
      }, {})

      this.categories = Object.values(this.groupedProducts)
        .map(group => group[0].category)
        .sort((a, b) => a.order - b.order)
      this.loading = false
    })

    if (this.$route.query.redirect === '/bagislarim') {
      this.$modal.show('login-modal')
    }
  }
}
</script>
<style  scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s;
}

.fade-enter-active {
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
